import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

const { gray900 } = colors;

const DEFAULT_COLOR = gray900;

const FONT_WEIGHTS = {
    regular: 400,
    semiBold: 500,
    bold: 600
} as const;

const body1 = {
    color: DEFAULT_COLOR,
    fontSize: "16px",
    lineHeight: "20px",
    letterSpacing: "0.15px"
} as const;

const body2 = {
    color: DEFAULT_COLOR,
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0.1px"
} as const;

const body3 = {
    color: DEFAULT_COLOR,
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: "0.4px"
} as const;

const body4 = {
    color: DEFAULT_COLOR,
    fontSize: "10px",
    lineHeight: "12px",
    letterSpacing: "1px"
} as const;

export const body1RegularStyles = {
    ...body1,
    fontWeight: FONT_WEIGHTS.regular
};

export const body1SemiBoldStyles = {
    ...body1,
    fontWeight: FONT_WEIGHTS.semiBold
};

export const body1BoldStyles = {
    ...body1,
    fontWeight: FONT_WEIGHTS.bold
};

export const body2RegularStyles = {
    ...body2,
    fontWeight: FONT_WEIGHTS.regular
};

export const body2SemiBoldStyles = {
    ...body2,
    fontWeight: FONT_WEIGHTS.semiBold
};

export const body2BoldStyles = {
    ...body2,
    fontWeight: FONT_WEIGHTS.bold
};

export const body3RegularStyles = {
    ...body3,
    fontWeight: FONT_WEIGHTS.regular
};

export const body3SemiBoldStyles = {
    ...body3,
    fontWeight: FONT_WEIGHTS.semiBold
};

export const body3BoldStyles = {
    ...body3,
    fontWeight: FONT_WEIGHTS.bold
};

export const body4RegularStyles = {
    ...body4,
    fontWeight: FONT_WEIGHTS.regular
};

export const body4SemiBoldStyles = {
    ...body4,
    fontWeight: FONT_WEIGHTS.semiBold
};

export const body4BoldStyles = {
    ...body4,
    fontWeight: FONT_WEIGHTS.bold
};

export const headline4Styles = {
    fontWeight: FONT_WEIGHTS.bold,
    color: DEFAULT_COLOR,
    fontSize: "32px",
    lineHeight: "40px",
    letterSpacing: "0.25px"
} as const;

export const body1Regular = css(body1RegularStyles);
export const body1SemiBold = css(body1SemiBoldStyles);
export const body1Bold = css(body1BoldStyles);
export const body2Regular = css(body2RegularStyles);
export const body2SemiBold = css(body2SemiBoldStyles);
export const body2Bold = css(body2BoldStyles);
export const body3Regular = css(body3RegularStyles);
export const body3SemiBold = css(body3SemiBoldStyles);
export const body3Bold = css(body3BoldStyles);
export const body4Regular = css(body4RegularStyles);
export const body4SemiBold = css(body4SemiBoldStyles);
export const body4Bold = css(body4BoldStyles);
export const headline4 = css(headline4Styles);
